export const wyoming = {
  "56000": "Wyoming",
  "56001": "Albany County",
  "56003": "Big Horn County",
  "56005": "Campbell County",
  "56007": "Carbon County",
  "56009": "Converse County",
  "56011": "Crook County",
  "56013": "Fremont County",
  "56015": "Goshen County",
  "56017": "Hot Springs County",
  "56019": "Johnson County",
  "56021": "Laramie County",
  "56023": "Lincoln County",
  "56025": "Natrona County",
  "56027": "Niobrara County",
  "56029": "Park County",
  "56031": "Platte County",
  "56033": "Sheridan County",
  "56035": "Sublette County",
  "56037": "Sweetwater County",
  "56039": "Teton County",
  "56041": "Uinta County",
  "56043": "Washakie County",
  "56045": "Weston County",
};
